module.exports = __webpack_public_path__ + "img/city2.69651e9e.jpg";